import { AnimatePresence, motion } from "motion/react";
import type { Scene } from "@/data/phases";
import { GearsScene } from "./scenes/GearsScene";
import { Clouds } from "./scenes/Clouds";
import { Stars } from "./scenes/Stars";

/**
 * The decorative backdrop.
 *
 * The gears are the constant — they run in every phase (the clock never
 * stops). On top of them an "atmosphere" layer crossfades with the time of
 * day: clouds in the morning, stars at night, nothing midday/dusk (the bare
 * mechanism). `kick` is the per-section lurch; `burst` speeds the gears up on
 * every phase change.
 */
export function Sky({ scene, kick, burst }: { scene: Scene; kick: number; burst: number }) {
  return (
    <>
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 1 }} aria-hidden="true">
        {/* always-on clockwork */}
        <GearsScene kick={kick} burst={burst} />

        {/* time-of-day atmosphere over the gears */}
        <AnimatePresence mode="sync">
          {scene !== "gears" && (
            <motion.div
              key={scene}
              style={{ position: "absolute", inset: 0 }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1.1, ease: "easeInOut" }}
            >
              {scene === "clouds" && <Clouds />}
              {scene === "stars" && <Stars />}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <div className="tc-scanline" aria-hidden="true" />
    </>
  );
}
